import { store } from "@/store/store";
import { eventBus } from "@/eventBus";
import { mapMutations, mapGetters } from "vuex";
import Utility from "@/mixins/Utility";

const Redirection = {
  methods: {
    ...mapMutations(["setFirebaseUserUID", "setRegActiveDeeplink", "setContentData", "setContentPlayingFromRails"]),
    ...mapGetters(["appConfig", "currentBrowser", "subscriberid", "availabilityList"]),

    redirectToLocator(content) {
      if(this.locatorData(content)) {
        window.open(this.locatorData(content), '_blank', 'noopener,noreferrer');
      }else {
        alert('sorry..! content is not accessible.')
      }
    }, 

    locatorData(content) {
      let locaterData = content?.contentdetails?.filter((item, i) =>{
        return item.devicetype === "web"
      });
      let locater = locaterData && locaterData[0]?.locator;
      if(locater && content?.contentprovider == "OTT_PLAY") {
          let token = localStorage.getItem("sessionToken");
          let source = "KCCL";
          let backUrl = encodeURIComponent(window.location.href);
          locater = `https://www.ottplay.com/auth?seoUrl=${locater}&token=${token}&backUrl=${backUrl}&source=${source}`;
      }
      return locater;
    },

    redirectToLogin(localDisplayLang) {
        // let payload = {
        //     state: true,
        //     formType: "lookup",
        // };
        // eventBus.$emit("authPopup", payload);
        this.$router.push({ name: "newLogin", params: { lang: localDisplayLang}});
    },

    // redirectToPlans() {
    //   eventBus.$emit('subscripe-popup-mvshub', true);
    //   // this.setRegActiveDeeplink(true);
    //   // localStorage.setItem("paymentGetwaySaveUrl", location.href);
    //   // let currentLanguage = this.getCurrentLanguageUrlBase();
    //   // this.$router.push({name: 'seeAllPlans', params: {lang: currentLanguage}});
    // },

    redirectToPlans(type) {
      const idToken = localStorage.getItem("idToken") || "";
      let url = "";
      if(type === 'subscribeButton') {
        url = `${this.appConfig?.urls?.subscriptionRedirection?.micuenta}${idToken}`;
      } else {
        url = `${this.appConfig?.urls?.subscriptionRedirection?.paquetes}${idToken}`;
      }
      window.open(url, "_blank");
    },

    redirectToDetailPage(item, screen) {
      console.log('getItem1',screen)
      console.log('getItem2',item)
      if(item.deeplink) {
        const parsed = new URL(item.deeplink);
        let redirectUrl = parsed.pathname.replace(/^\/+/, '');
        if(redirectUrl.includes('catchup')){
          let channelid = redirectUrl.split('/')[2];
          console.log('channelid',channelid)
           this.$router.push({
            name: 'catchup', 
            params: { id: channelid},
        });
        return;
        }
        console.log('redirectUrl', redirectUrl);
        let sectionTitle = redirectUrl.split('/')[1];
        let currentLanguage = this.getCurrentLanguageUrlBase();
        this.$router.push({
            name: 'cp-screen', 
            params: { section: sectionTitle, lang: currentLanguage },
        });
        return;
      }
      this.setContentPlayingFromRails(screen);
      this.setContentData(item);
      console.log('redirectToDetailPage', item);
      let category = 'movies';
      if (item?.category?.toLowerCase() == 'tvshow') {
          category = 'tvshows';
      } else if (item?.category?.toLowerCase() == 'movie') {
          category ='movies';
      } else if (item?.category?.toLowerCase() == 'tvchanel') {
          category = 'livetv';
      } else if (item?.objecttype?.toLowerCase() == 'season') {
          category = 'tvshows';
      } 
      this.$router.push({
          name: 'detailPageEarth', params: {
          category: category,
          title: this.cleanString(item.title),
          contentId: item.objecttype == "SEASON" ? item.seriesid : item.objectid
          }
      });
    },

    redirectToSeeAll(screen) {

      let currentLanguage = this.getCurrentLanguageUrlBase();
      console.log("redirectToSeeAll", screen);
      if(screen?.title?.default?.toLowerCase() == "continue watching") {
        this.$router.push({
          name: "seeAllContinueWatch",
          params: {lang: currentLanguage },
        });
      } else if(screen?.title?.default?.toLowerCase() == "watch list") {
        this.$router.push({
          name: "Watchlist",
          params: {lang: currentLanguage },
        });
      } else {
        let screenData = JSON.stringify(screen);
        localStorage.setItem("screen-list-collection", screenData);
        let titleDefault = this.spacialCharEncoding(screen.title.default);
        this.$router.push({
          name: "collections",
          params: { section: titleDefault.toLowerCase(), slug: this.screenId, lang: currentLanguage },
        });
      }
    },

    cleanString(input) {
      return input
          .toLowerCase() // Convert to lowercase for consistency
          .replace(/[^a-z0-9\s-]/g, '-') // Replace special characters with hyphens
          .replace(/\s+/g, '-') // Replace spaces with a single hyphen
          .replace(/-+/g, '-') // Replace multiple hyphens with a single hyphen
          .replace(/^-|-$/g, ''); // Remove leading or trailing hyphens
    },

    redirectToExternaldeeplinkurlbasedplayback(contentData) {
      const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
      const urlencoded = new URLSearchParams();
      urlencoded.append("contentid", contentData.objectid);
      urlencoded.append("ios", isSafari ? true : false);
      urlencoded.append("seclevel", "SW");
      let drmPromise = store.dispatch("actGetDRMToken", urlencoded);
      Promise.all([drmPromise])
      .then(async ([drmRes]) => {
          console.log("redirectToExternaldeeplinkurlbasedplayback", drmRes.data);
          let contentData = drmRes.data;
          if(contentData.deeplinkplaybackDetails) {
           let playbackUrl = contentData.deeplinkplaybackDetails.playbackUrls[0].playbackUrl;
           let sessionId = contentData.deeplinkplaybackDetails.playbackUrls[0].sessionId;
           let stageUrl = `${playbackUrl}&sessionId=${sessionId}`;
           console.log('playbackUrl', stageUrl);
           window.open(playbackUrl, '_blank');
          }
      })
      .catch((err) => {
          console.log("err", err);
      }); 
    }
  },
  mixins: [Utility],
};

export default Redirection;